// models/guestGroup.js
import { createGuest } from "./guest";

// Returns a new blank guest group object
export const createGuestGroup = () => ({
  id: "",
  email: "",
  message: "",
  hasResponded: false, //whether or not the guest group has responded, default
  hasSubmittedMealPref: false, //whether or not the guest group has submitted meal preferences, default
  guests: [createGuest()],
});

// Converts a Firestore doc to guestGroup
export const fromFirestoreDoc = (doc) => ({
  id: doc.id,
  ...doc.data(),
  message: doc.data().message || "", // ensure message is at least an empty string
  hasResponded: doc.data().hasResponded || false, // ensure hasResponded is at least false
  hasSubmittedMealPref: doc.data().hasSubmittedMealPref || false, // ensure hasSubmittedMealPref is at least false
  guests: doc.data().guests.map((g) => ({
    name: g.name || "",
    isAttendingCeremony: !!g.isAttendingCeremony,
    isAttendingReception: !!g.isAttendingReception,
    mealPreference: g.mealPreference || "",
    dietaryRestrictions: g.dietaryRestrictions || "",
  })),
});

// Converts guestGroup to a Firestore-compatible object (excluding id)
export const toFirestoreGuestGroup = (group) => ({
  email: group.email,
  message: group.message,
  hasResponded: group.hasResponded, // Make sure this is saved
  hasSubmittedMealPref: group.hasSubmittedMealPref, // Make sure this is saved
  guests: group.guests.map((g) => ({
    name: g.name,
    isAttendingCeremony: !!g.isAttendingCeremony,
    isAttendingReception: !!g.isAttendingReception,
    mealPreference: !!g.mealPreference || "",
    dietaryRestrictions: !!g.dietaryRestrictions || "",
  })),
});
